export function detectAds() {
	// https://christianheilmann.com/2015/12/25/detecting-adblock-without-an-extra-http-overhead/
	let test = document.createElement('div');
	test.innerHTML = '&nbsp;';
	test.className = 'adsbox';
	document.body.appendChild(test);
	window.setTimeout(function () {
		// also disable_shemedia_on_pages
		if (0 === test.offsetHeight || 'page' === document.body.dataset.posttype) {
			document.body.setAttribute('data-ads', 'false');
		} else {
			document.body.setAttribute('data-ads', 'true');
		}
		test.remove();
	}, 500);
}
